import { render } from "./FundsTable.vue?vue&type=template&id=3976e926&scoped=true"
import script from "./FundsTable.vue?vue&type=script&lang=js"
export * from "./FundsTable.vue?vue&type=script&lang=js"

import "./FundsTable.vue?vue&type=style&index=0&id=3976e926&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3976e926"]])

export default __exports__